import { TYPO } from "styles/Typo";
import { useTranslation } from "next-i18next";
import useModalClickOutside from "utils/useModalClickOutside";
import CenterModal from "components/common/Modal/CenterModal";
import useWithdraw from "utils/clientAPIs/withdraw";
import Button from "components/common/buttons/buttons";
import { Router, useRouter } from "next/router";

interface props {
  setModalOpen: (value: boolean) => void;
}

const WarningIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="white" />
      <rect x="2" y="17" width="20" height="3" rx="1" fill="#D9D9D9" />
      <path
        d="M5.38392 5.75569C5.5073 4.75316 6.35885 4 7.36894 4H16.6311C17.6412 4 18.4927 4.75316 18.6161 5.75569L20 17H4L5.38392 5.75569Z"
        fill="var(--red40)"
      />
      <circle cx="12" cy="11" r="4" fill="var(--red50)" />
    </svg>
  );
};

const DetailNotiModal = ({ setModalOpen }: props) => {
  const modalRef = useModalClickOutside(setModalOpen); // 모달 참조를 위한 ref 추가

  const { t } = useTranslation("detail");

  const router = useRouter();

  return (
    <CenterModal modalRef={modalRef} containerClass="gap-4 !p-5 !w-[327px]">
      <div className=" flex-col flex gap-3">
        <div className="flex gap-2 items-center">
          <WarningIcon />
          <span className={`${TYPO.TYPO5_1_SB} text-gray70`}>
            {router.locale === "ko" ? "알려드립니다" : "Notice"}
          </span>
        </div>
        <div className={`${TYPO.TYPO7_MD} text-gray60`}>
          {router.locale === "ko" ? (
            <div className="flex flex-col gap-2">
              <span className={`${TYPO.TYPO7_SB} text-gray70`}>
                리스크웨더는 개인투자자 보호에 앞장섭니다.
              </span>

              <span className={`${TYPO.TYPO7_RG} text-gray70`}>
                사칭이나 리딩방, 사기성 추천 등의 불법 행위와 일절 무관함을
                알려드립니다.
              </span>
            </div>
          ) : (
            <>
              <span className={`${TYPO.TYPO7_RG} text-gray70`}>
                RiskWeather provides only risk information for investment
                products
              </span>
              <br />
              <span className={`${TYPO.TYPO7_SB} text-gray70`}>
                We do not engage in any advertising related to illegal
                investment solicitations, impersonation of celebrities, or any
                other forms of investment fraud.
              </span>
            </>
          )}
        </div>
        <div>
          <Button
            type="tertiary"
            text={router.locale === "ko" ? "확인" : "Confirm"}
            size="md"
            width="w-full"
            clickHandler={() => {
              const tomorrow = new Date();
              tomorrow.setDate(tomorrow.getDate() + 1);
              localStorage.setItem(
                "detailNotiModalHide",
                tomorrow.toISOString()
              );
              setModalOpen(false);
            }}
            btnClass="noti-confirm"
          />
        </div>
      </div>
    </CenterModal>
  );
};

export default DetailNotiModal;
